// ============================================================
// Bases partagées entre deux groupes de jeu (Paramètres > Projets)
// ============================================================
// Même règle que la sonde du panel (ProjectHealthService.sharedDatabases) : une base propre au groupe
// n'est partagée que si le serveur ET le nom sont les mêmes. Le satellite annonce le serveur de chaque
// base depuis la 1.0.19 (`databaseServers` de son /api/_meta) ; face à un satellite plus ancien, seul
// le nom est comparé, comme avant. Fonctions pures, testées par sharedDatabases.test.ts (node --test).

/**
 * Bases propres à un groupe : partagées, elles mélangent les données. Points boutique (storepoint),
 * carte des pays (worlds) et métiers (jobs) sont communs exprès : jamais signalés.
 */
export const GROUP_DATABASES = ['moderation', 'essentials', 'vault', 'market', 'stats', 'satellite'];

/**
 * - `shared` : même nom et même serveur ;
 * - `sameName` : même nom, serveur inconnu d'un côté (satellite d'avant la 1.0.19) : signalé comme avant ;
 * - `null` : rien à signaler (base commune exprès, noms ou serveurs différents, base absente d'un côté).
 */
export type SharedVerdict = 'shared' | 'sameName' | null;

export function sharedVerdict(
  logical: string,
  rootDb: string | undefined,
  targetDb: string | undefined,
  rootServer: string | undefined,
  targetServer: string | undefined,
): SharedVerdict {
  if (!GROUP_DATABASES.includes(logical) || !rootDb || rootDb !== targetDb) return null;
  if (!rootServer || !targetServer) return 'sameName';
  return rootServer.toLowerCase() === targetServer.toLowerCase() ? 'shared' : null;
}

/** Une case du tableau « Bases utilisées » : la base, et son serveur quand le satellite l'annonce. */
export function databaseCell(db: string | undefined, server: string | undefined): string {
  if (!db) return '(aucune)';
  return server ? `${db} · ${server}` : db;
}

/** Ce qui suit la base de la cible quand elle est signalée. */
export function verdictSuffix(verdict: SharedVerdict): string {
  if (verdict === 'shared') return ' : partagée (même serveur)';
  if (verdict === 'sameName') return ' : même nom, serveur non annoncé (satellite d’avant la 1.0.19)';
  return '';
}
